import React, { useCallback } from "react";
import { Link, useLocation } from "react-router-dom";
import MainTitle from "../MainTitle/MainTitle";

export default function Header() {
  const location = useLocation();

  // تابع اسکرول نرم به یک id خاص فقط در صفحه اصلی
  const handleScrollToSection = useCallback(
    (e, sectionId) => {
      if (location.pathname === "/") {
        e.preventDefault();
        const section = document.getElementById(sectionId);
        if (section) {
          section.scrollIntoView({ behavior: "smooth" });
        }
      }
      // اگر صفحه اصلی نبود، اجازه بده لینک کار خودش رو بکنه (ریدایرکت به صفحه اصلی)
    },
    [location.pathname]
  );

  // تعیین لینک هر بخش بر اساس صفحه فعلی
  const aboutUsLink = location.pathname === "/" ? "#AboutUs" : "/";
  const homeLink = location.pathname === "/" ? "#Home" : "/";
  const gameModesLink = location.pathname === "/" ? "#GameModes" : "/";

  return (
    <>
      {/* Header Background image */}
      <header className="w-full sticky top-5 md:top-0 left-0 right-0 z-[999] px-4 md:px-0">
        {/* Home Navbar Full width */}
        <div className="mt-5 " style={{ direction: "rtl" }}>
          {/* Header Container in the Navbar */}
          <div
            className="container h-20
          flex
          items-center
          justify-between
          px-5
          rounded-[12px]
          border
          border-[rgb(41,45,57)]
          bg-[rgba(24,27,36,0.5)]
          backdrop-blur-[10px]
          transition-all
          duration-300
          ease-[cubic-bezier(.075,.82,.165,1)] "
          >
            <div className="w-full">
              {/* Container Header content */}
              <div className="flex flex-row items-center justify-between">
                {/* Right logo */}
                <div className="">
                  <Link to="/">
                    <img
                      src="./images/trexmine.png"
                      alt=""
                      className="w-full h-full"
                    />
                  </Link>
                </div>
                {/* Center Navbar Menu */}
                <div className="hidden md:block">
                  <ul className="flex flex-row text-[#c1c1c1] gap-x-[30px] font-DanaMedium text-lg">
                    <li>
                      {/* شرط برای لینک خانه */}
                      <Link
                        to={homeLink}
                        onClick={(e) => handleScrollToSection(e, "Home")}
                        style={{ cursor: "pointer" }}
                      >
                        خانه
                      </Link>
                    </li>
                    <li>
                      {/* شرط برای لینک درباره ما */}
                      <Link
                        to={aboutUsLink}
                        onClick={(e) => handleScrollToSection(e, "AboutUs")}
                        style={{ cursor: "pointer" }}
                      >
                        درباره ما
                      </Link>
                    </li>
                    <li>
                      {/* شرط برای لینک گیم مود ها */}
                      <Link
                        to={gameModesLink}
                        onClick={(e) => handleScrollToSection(e, "GameModes")}
                        style={{ cursor: "pointer" }}
                      >
                        گیم مود ها
                      </Link>
                    </li>
                    <li>
                      {/* 
                        توضیح: تابع arrow داخل JSX فقط یک تابع است و ری‌اکت آن را اجرا نمی‌کند. برای اجرای شرط و نمایش خروجی، مستقیماً شرط را در JSX بنویس: 
                      */}
                      {localStorage.getItem("user") ? null : (
                        <Link to="/login">ورود</Link>
                      )}
                    </li>
                  </ul>
                </div>

                {/* Left Login Button */}

                <div>
                  {localStorage.getItem("user") ? (
                    <div className="relative group flex items-center gap-x-4 text-gray-300 bg-gradient-to-l from-[#23272F] to-transparent hover:from-[#292d36] hover:bg-opacity-80 transition-all duration-200 p-2 rounded-xl shadow-sm cursor-pointer hover:mb-2">
                      {/* User Avatar + Info */}
                      <img
                        className="w-11 h-11 rounded-xl ring-2 ring-[#e3ff59] shadow-sm object-cover"
                        alt="User avatar"
                        src="./images/players/player1.png"
                      />
                      <div className="flex flex-col items-end">
                        <span className="font-DanaDemiBold text-lg text-white">
                          کاربر
                        </span>
                        <span className="text-xs text-mainGray mt-1">
                          امتیاز:{" "}
                          <span className="font-semibold text-[#e3ff59]">
                            128
                          </span>
                        </span>
                      </div>
                      {/* Dropdown box on hover - FIX: add hover area bridge */}
                      <div className="absolute left-0 right-0 top-[99%] h-6 z-40"></div>
                      <div
                        className="absolute left-0 right-0 top-[110%] bg-white/10 bg-clip-padding backdrop-blur-lg backdrop-saturate-150 border border-white/30 text-white rounded-xl shadow-xl p-5 z-50 hidden group-hover:flex flex-col items-stretch min-w-[210px] text-right space-y-3"
                        style={{
                          boxShadow:
                            "0 8px 24px 0 rgba(40,45,65,0.13),0 1.5px 5px 0 rgba(220,233,255,0.05)",
                          WebkitBackdropFilter: "blur(20px) saturate(135%)",
                          backdropFilter: "blur(20px) saturate(135%)",
                        }}
                      >
                        <div className="flex flex-col items-end mb-3">
                          <span className="font-bold text-base pb-1 border-b border-[#e3ff59] w-full text-right">
                            پروفایل کاربری
                          </span>
                        </div>
                        <button className="transition-all group/settings flex items-center w-full px-2 py-2.5 rounded-md text-sm hover:bg-white/20 focus:bg-white/20 text-white font-DanaMedium">
                          <svg
                            className="ml-2"
                            width="18"
                            height="18"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="1.4"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            viewBox="0 0 24 24"
                          >
                            <circle cx="12" cy="12" r="3" />
                            <path d="M19.4 15A1.65 1.65 0 0 0 21 12.94a1.65 1.65 0 0 0-.33-1.82l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 .42l-.06.06c-.14.14-.23.33-.24.54a3.415 3.415 0 1 1-2.84 2.84c.21-.01.41-.1.54-.24l.06-.06a1.65 1.65 0 0 0 .42-1 1.65 1.65 0 0 0-.33-1.82l-.06-.06a1.65 1.65 0 0 0-1.82-.33A1.65 1.65 0 0 0 9 12.06a1.65 1.65 0 0 0-.24.54 3.415 3.415 0 1 1-2.84-2.84c.01-.21.1-.41.24-.54l.06-.06a1.65 1.65 0 0 0 .42-1 1.65 1.65 0 0 0-.33-1.82l-.06-.06a1.65 1.65 0 0 0-1.82-.33A1.65 1.65 0 0 0 3 7.06a1.65 1.65 0 0 0 .33 1.82l.06.06c.14.14.23.33.24.54a3.415 3.415 0 1 1 2.84 2.84c-.21.01-.41.1-.54.24l-.06.06a1.65 1.65 0 0 0-.42 1 1.65 1.65 0 0 0 .33 1.82l.06.06c.14.14.33.23.54.24a3.415 3.415 0 1 1 2.84-2.84c-.01-.21-.1-.41-.24-.54l-.06-.06a1.65 1.65 0 0 0-1-.42z" />
                          </svg>
                          تنظیمات
                        </button>
                        <button className="transition-all flex items-center w-full px-2 py-2.5 rounded-md text-sm hover:bg-white/20 focus:bg-white/20 text-white font-DanaMedium">
                          <svg
                            className="ml-2"
                            width="18"
                            height="18"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            viewBox="0 0 24 24"
                          >
                            <path d="M9 21h6a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2H9a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2z" />
                            <path d="M16 3v4" />
                            <path d="M8 3v4" />
                            <path d="M3 13h18" />
                          </svg>
                          آمار شما
                        </button>
                        <button className="transition-all flex items-center w-full px-2 py-2.5 rounded-md bg-[#e3ff59] hover:bg-yellow-200 text-darkGray font-DanaDemiBold mt-1">
                          <svg
                            className="ml-2"
                            width="18"
                            height="18"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="1.7"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            viewBox="0 0 24 24"
                          >
                            <path d="M17 16l4-4-4-4" />
                            <path d="M21 12H7" />
                            <path d="M7 19V5" />
                          </svg>
                          خروج
                        </button>
                      </div>
                    </div>
                  ) : (
                    <Link
                      to="/login"
                      className="btn-primary text-md px-4 rounded-lg py-2"
                    >
                      ورود / ثبت نام
                    </Link>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>
    </>
  );
}
